<template>
  <v-footer class="pa-0 flex-0-0 " color="primary">
    <v-row class="web-info ma-0">
      <v-col
        :class="
          $vuetify.display.lgAndUp
            ? 'text-center secondary--text pa-1'
            : 'text-center secondary--text'
        "
        cols="12"
      >
        <i18n-t tag="span" keypath="footer.web_info.host" scope="global">
          <template v-slot:link>
            <a
              href="https://www.ist.com/no/"
              target="_blank"
              style="font-weight: bold; color: white; text-decoration: underline; cursor: pointer"
              >IST</a
            >
          </template>
        </i18n-t>
      </v-col>
      <v-col
        :class="
          $vuetify.display.lgAndUp
            ? 'text-center secondary--text pa-1'
            : 'text-center secondary--text'
        "
        cols="12"
      >
        <i18n-t tag="span" keypath="footer.web_info.gdpr" scope="global">
          <template v-slot:link>
            <a
              href="https://vigo.no/nyvigo/documents/Personvernerklæring_VIGO.pdf"
              target="_blank"
              style="font-weight: bold; color: white; text-decoration: underline; cursor: pointer"
              >personvernerklæring.
            </a>
          </template>
        </i18n-t>
      </v-col>
    </v-row>
  </v-footer>
</template>
<style scoped lang="scss">
.web-info {
  background-color: #003440;
}
</style>
